/**
 * @generated SignedSource<<57ea5fc2859155465098eb69ed722c13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StreamAccessType = "full" | "partial" | "shared";
export type ShareSectionMutation$variables = {
  captchaToken: string;
  emails: ReadonlyArray<string>;
  id: string;
};
export type ShareSectionMutation$data = {
  readonly noteStreamShare: {
    readonly noteStream: {
      readonly id: string;
      readonly index: number | null;
      readonly notes: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly noteuserSet: ReadonlyArray<{
              readonly id: string;
              readonly user: {
                readonly __typename: "User";
                readonly email: string;
                readonly firstName: string;
                readonly fullName: string;
                readonly id: string;
                readonly image: string;
                readonly isActive: boolean;
                readonly isConfigured: boolean;
                readonly isGuest: boolean;
              };
            }>;
          } | null;
        } | null>;
      } | null;
      readonly notestreamusers: ReadonlyArray<{
        readonly accessType: StreamAccessType;
        readonly id: string;
        readonly user: {
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly hasReceivedInvites: boolean;
          readonly id: string;
          readonly image: string;
          readonly isActive: boolean;
          readonly isConfigured: boolean;
          readonly isGuest: boolean;
          readonly lastName: string;
        };
      }>;
      readonly pendingStreamInvites: ReadonlyArray<{
        readonly email: string;
        readonly id: string;
        readonly isExpired: boolean;
      }> | null;
      readonly userCount: number;
    };
  } | null;
};
export type ShareSectionMutation = {
  response: ShareSectionMutation$data;
  variables: ShareSectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "captchaToken"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emails"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "captchaToken",
        "variableName": "captchaToken"
      },
      {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "NoteStreamShare",
    "kind": "LinkedField",
    "name": "noteStreamShare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "index",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamUser",
            "kind": "LinkedField",
            "name": "notestreamusers",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accessType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasReceivedInvites",
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamInvite",
            "kind": "LinkedField",
            "name": "pendingStreamInvites",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isExpired",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              }
            ],
            "concreteType": "NotesConnection",
            "kind": "LinkedField",
            "name": "notes",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Note",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NoteUser",
                        "kind": "LinkedField",
                        "name": "noteuserSet",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v7/*: any*/),
                              (v6/*: any*/),
                              (v5/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "notes(first:3)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareSectionMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ShareSectionMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "497e4ded5f25f5984a51bbfdc396d94b",
    "id": null,
    "metadata": {},
    "name": "ShareSectionMutation",
    "operationKind": "mutation",
    "text": "mutation ShareSectionMutation(\n  $id: ID!\n  $emails: [String!]!\n  $captchaToken: String!\n) {\n  noteStreamShare(id: $id, emails: $emails, captchaToken: $captchaToken) {\n    noteStream {\n      id\n      index\n      userCount\n      notestreamusers {\n        id\n        accessType\n        user {\n          id\n          email\n          image\n          fullName\n          lastName\n          firstName\n          isActive\n          isConfigured\n          hasReceivedInvites\n          isGuest\n        }\n      }\n      pendingStreamInvites {\n        id\n        email\n        isExpired\n      }\n      notes(first: 3) {\n        edges {\n          node {\n            id\n            noteuserSet {\n              id\n              user {\n                __typename\n                id\n                email\n                firstName\n                fullName\n                image\n                isActive\n                isConfigured\n                isGuest\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91301de38f2225c912c0e37d22206e72";

export default node;
